import { z } from 'zod';
import { TEXT_AREA_MAX_LENGTH } from '@constants';
import {
  stringConstraints,
  stringFieldSchema,
  arrayFieldSchema,
} from '@shared/schemas';

export const detailOfIssueSchema = z.object({
  describeTheIssue: stringConstraints(
    'There is a problem. Enter a description of the issue.',
  ).refine((value) => value.length <= TEXT_AREA_MAX_LENGTH, {
    message: `Field must be ${TEXT_AREA_MAX_LENGTH} characters or less.`,
    path: ['describeTheIssue'],
  }),
  describeThePerformer: stringConstraints(
    'There is a problem. Enter a description of the performer.',
  ).refine((value) => value.length <= TEXT_AREA_MAX_LENGTH, {
    message: `Field must be ${TEXT_AREA_MAX_LENGTH} characters or less.`,
    path: ['describeThePerformer'],
  }),
});

// The error message in this schema differs from the existing binaryOptionSchema

export const contactUserOptionsSchema = stringFieldSchema(
  'canWeContactYou',
  'Please select an option to proceed',
);
export const issueTypeSchema = arrayFieldSchema(
  'issueTypes',
  'Please select at least one option',
);

export const yourDetailsSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  email: z.string().email('Invalid email address'),
});
